import BawangMerah from '../assets/icons/commodities/BawangMerah';
import BawangPutih from '../assets/icons/commodities/BawangPutih';
import Beras from '../assets/icons/commodities/Beras';
import CabaiMerah from '../assets/icons/commodities/CabaiMerah';
import CabaiRawit from '../assets/icons/commodities/CabaiRawit';
import DagingAyam from '../assets/icons/commodities/DagingAyam';
import DagingSapi from '../assets/icons/commodities/DagingSapi';
import GulaPasir from '../assets/icons/commodities/GulaPasir';
import MinyakGoreng from '../assets/icons/commodities/MinyakGoreng';
import TelurAyam from '../assets/icons/commodities/TelurAyam';

import {CerahMalam, CerahPagi, CerahBerawanMalam, CerahBerawanPagi,
	BerawanMalam, BerawanPagi, BerawanTebalMalam,BerawanTebalPagi,
	KabutPagi,KabutMalam,HujanRinganMalam,HujanRinganPagi,HujanLebat,
	HujanSedang} from '../assets/icons/weather';
// import Histogram from '../views/chart/histogram';
import React from 'react';



export const comColor ={
	'bawang_merah' : ['rgba(4, 80, 180, 1)'],
	'bawang_putih' : ['rgba(4, 109, 200,1)'],
	'cabai_merah' : ['rgba(17, 132, 167, 1)'],
	'cabai_rawit' : ['rgba(21, 162, 162,1)'],
	'daging_ayam' : ['rgba(111, 177, 160,1)'],
	'daging_sapi' : ['rgba(180, 65, 142,1)'],
	'telur_ayam' : ['rgba(217, 74, 140,1)'],
	'minyak_goreng' : ['rgba(234, 81, 95,1)'],
	'gula_pasir' : ['rgba(254, 116, 52,1)'],
	'beras' : ['rgba(254, 168, 2,1)'],

};

export const comColorAlpha ={
	'bawang_merah' : ['rgba(4, 80, 180, 0.6)'],
	'bawang_putih' : ['rgba(4, 109, 200,0.6)'],
	'cabai_merah' : ['rgba(17, 132, 167, 0.6)'],
	'cabai_rawit' : ['rgba(21, 162, 162,0.6)'],
	'daging_ayam' : ['rgba(111, 177, 160,0.6)'],
	'daging_sapi' : ['rgba(180, 65, 142,0.6)'],
	'telur_ayam' : ['rgba(217, 74, 140,0.6)'],
	'minyak_goreng' : ['rgba(234, 81, 95,0.6)'],
	'gula_pasir' : ['rgba(254, 116, 52,0.6)'],
	'beras' : ['rgba(254, 168, 2,0.6)'],

};


export const measurementsDict = {
	'temperature' : 'Suhu Udara',
	'relative_humidity': 'Kelembapan Udara',
	'ambient_light' : 'Cahaya Sekitar',
	'solar_voltage' : 'Voltase Matahari',
	'battery' : 'Tegangan Baterai',

	'soil_temperature':'Suhu Tanah',
	'soil_moisture' : 'Kelembapan Tanah',
	'nitrogen' : 'Kadar Nitrogen Tanah',
	'phosphorous': 'Kadar Fosfat Tanah',
	'potassium' : 'Kadar Kalium Tanah',
	'soil_conductivity' : 'Konduktivitas Tanah',
	'soil_ph' : 'Keasaman Tanah',

}
export const sensorList = [
	{
		locationName: 'Hutamanik, Dairi',
		region:"sumatera_utara",
		latitude: '2.7605',
		longitude: '98.45527',
		nodeID : 'node_30',
		// nodeID : 'node_2',
		urlType : 'hutamanik-dairi'
	},
	{
		locationName: 'Tanjung Beringin II, Dairi',
		region:"sumatera_utara",
		latitude: '2.76765',
		longitude: '98.38856',
		nodeID : 'node_31',
		// nodeID : 'node_2',
		urlType : 'tanjung-beringin-dairi'
	},
	{
		locationName: 'Food Estate, Ria-Ria',
		region:"sumatera_utara",
		latitude: '2.401455',
		longitude: '98.7205533',
		nodeID : 'node_26',
		// nodeID : 'node_23',
		urlType : 'estate-riaria'
	},
	{
		locationName: 'Poasia, Kota Kendari',
		region: "sulawesi_tenggara",
		latitude: '-4.031772',
		longitude: '122.545850',
		nodeID : 'node_9',
		urlType : 'poasia-kendari'
	},
	// {
	// 	locationName: 'TSTH2 Tanah Mineral I, Humbang Hasundutan',
	// 	region: "sumatera_utara",
	// 	latitude: '2.296683',
	// 	longitude: '98.628006',
	// 	nodeID : 'node_24',
	// 	urlType : 'tsth-tanah-gambut-i'
	// },
	{
		locationName: 'TSTH2 Ladang Cabai, Humbang Hasundutan',
		region: "sumatera_utara",
		latitude: '2.294358',
		longitude: '98.626526',
		nodeID : 'node_25',
		urlType : 'tsth-tanah-gambut-ii'
	},
	{
		locationName: 'TSTH2 Tanah Ladang Kubis, Humbang Hasundutan',
		region: "sumatera_utara",
		latitude: '2.295805',
		longitude: '98.627561',
		nodeID : 'node_12',
		//tadinya node 11
		urlType : 'tsth-tanah-mineral'
	},
	{
		locationName: 'Sobat Budaya, Tebet',
		region: "sobat_budaya",
		latitude: '-6.2351736',
		longitude: '106.8480544',
		nodeID : 'node_15',
		urlType : 'tebet-jakarta'
	}
]

export const marvestSensorList = [

	{
		locationName: 'Food Estate, Ria-Ria',
		region:"sumatera_utara",
		latitude: '2.401455',
		longitude: '98.7205533',
		nodeID : 'node_26',
		urlType : 'estate-riaria'
	},
	// {
	// 	locationName: 'TSTH2 Tanah Mineral I, Humbang Hasundutan',
	// 	region: "sumatera_utara",
	// 	latitude: '2.296683',
	// 	longitude: '98.628006',
	// 	nodeID : 'node_24',
	// 	urlType : 'tsth-tanah-mineral-i'
	// },
	{
		locationName: 'TSTH2 Ladang Cabai, Humbang Hasundutan',
		region: "sumatera_utara",
		latitude: '2.294358',
		longitude: '98.626526',
		nodeID : 'node_25',
		urlType : 'tsth-tanah-gambut'
	},
	{
		// Mineral II
		locationName: 'TSTH2 Ladang Kubis, Humbang Hasundutan',
		region: "sumatera_utara",
		latitude: '2.295805',
		longitude: '98.627561',
		nodeID : 'node_12',
		//tadinya node 11
		urlType : 'tsth-tanah-mineral-ii'
	}
]

export const estateSensorList = [
	{
		locationName: 'Food Estate, Ria-Ria',
		region:"sumatera_utara",
		latitude: '2.401455',
		longitude: '98.7205533',
		nodeID : 'node_26',
		urlType : 'estate-riaria'
	}
]


export const cDict =
    {'kab_banyumas': 'Kabupaten Banyumas',
    	'kab_banyuwangi': 'Kabupaten Banyuwangi',
    	'kab_boyolali': 'Kabupaten Boyolali',
    	'kab_bulukumba': 'Kabupaten Bulukumba',
    	'kab_bulungan': 'Kabupaten Bulungan',
    	'kab_bungo': 'Kabupaten Bungo',
    	'kab_cilacap': 'Kabupaten Cilacap',
    	'kab_cirebon': 'Kabupaten Cirebon',
    	'kab_jember': 'Kabupaten Jember',
    	'kab_karanganyar': 'Kabupaten Karanganyar',
    	'kab_klaten': 'Kabupaten Klaten',
    	'kab_kotabaru': 'Kabupaten Kotabaru',
    	'kab_kudus': 'Kabupaten Kudus',
    	'kab_lombok_timur': 'Kabupaten Lombok Timur',
    	'kab_majene': 'Kabupaten Majene',
    	'kab_mamuju': 'Kabupaten Mamuju',
    	'kab_manokwari': 'Kabupaten Manokwari',
    	'kab_merauke': 'Kabupaten Merauke',
    	'kab_mimika': 'Kabupaten Mimika',
    	'kab_polewali_mandar': 'Kabupaten Polewali Mandar',
    	'kab_sintang': 'Kabupaten Sintang',
    	'kab_sragen': 'Kabupaten Sragen',
    	'kab_sukoharjo': 'Kabupaten Sukoharjo',
    	'kab_sumba_timur': 'Kabupaten Sumba Timur',
    	'kab_sumbawa': 'Kabupaten Sumbawa',
    	'kab_sumenep': 'Kabupaten Sumenep',
    	'kab_tasikmalaya': 'Kabupaten Tasikmalaya',
    	'kab_wonogiri': 'Kabupaten wonogiri',
    	'kota_ambon': 'kota_ambon',
    	'kota_balikpapan': 'kota_balikpapan',
    	'kota_banda_aceh': 'Kota Banda Aceh',
    	'kota_bandar_lampung': 'Kota Bandar Lampung',
    	'kota_bandung': 'Kota Bandung',
    	'kota_banjarmasin': 'Kota Banjarmasin',
    	'kota_batam': 'Kota Batam',
    	'kota_bau_bau': 'Kota Bau Bau',
    	'kota_bekasi': 'Kota Bekasi',
    	'kota_bengkulu': 'Kota Bengkulu',
    	'kota_bima': 'Kota Bima',
    	'kota_blitar': 'Kota Blitar',
    	'kota_bogor': 'Kota Bogor',
    	'kota_bone': 'Kota Bone',
    	'kota_bontang': 'Kota Bontang',
    	'kota_bukittinggi': 'Kota Bukittinggi',
    	'kota_cilegon': 'kota_cilegon',
    	'kota_cirebon': 'Kota Cirebon',
    	'kota_denpasar': 'Kota Denpasar',
    	'kota_depok': 'Kota Depok',
    	'kota_dumai': 'Kota Dumai',
    	'kota_gorontalo': 'Kota Gorontalo',
    	'kota_gunung_sitoli': 'Kota Gunung Sitoli',
    	'kota_jakarta_pusat': 'Kota Jakarta Pusat',
    	'kota_jambi': 'Kota Jambi',
    	'kota_jayapura': 'Kota Jayapura',
    	'kota_kediri': 'Kota Kediri',
    	'kota_kendari': 'Kota Kendari',
    	'kota_kotamobagu': 'Kota Kotamobagu',
    	'kota_kupang': 'Kota Kupang',
    	'kota_lhokseumawe': 'Kota Lhokseumawe',
    	'kota_lubuk_linggau': 'Kota Lubuk Linggau',
    	'kota_madiun': 'Kota Madiun',
    	'kota_makassar': 'Kota Makassar',
    	'kota_malang': 'Kota Malang',
    	'kota_mamuju': 'Kota Mamuju',
    	'kota_manado': 'Kota Manado',
    	'kota_mataram': 'Kota Mataram',
    	'kota_maumere': 'Kota Maumere',
    	'kota_medan': 'Kota Medan',
    	'kota_metro': 'Kota Metro',
    	'kota_meulaboh': 'Kota Meulaboh',
    	'kota_padang': 'Kota Padang',
    	'kota_padang_sidempuan': 'Kota Padang Sidempuan',
    	'kota_palangkaraya': 'Kota Palangkaraya',
    	'kota_palembang': 'Kota Palembang',
    	'kota_palopo': 'Kota Palopo',
    	'kota_palu': 'Kota Palu',
    	'kota_pangkal_pinang': 'Kota Pangkal Pinang',
    	'kota_parepare': 'Kota Pare Pare',
    	'kota_pekanbaru': 'Kota Pekanbaru',
    	'kota_pematang_siantar': 'Kota Pematang Siantar',
    	'kota_pontianak': 'Kota Pontianak',
    	'kota_probolinggo': 'Kota Probolinggo',
    	'kota_samarinda': 'Kota Samarinda',
    	'kota_sampit': 'Kota Sampit',
    	'kota_semarang': 'Kota Semarang',
    	'kota_serang': 'Kota Serang',
    	'kota_sibolga': 'Kota Sibolga',
    	'kota_singaraja': 'Kota Singaraja',
    	'kota_singkawang': 'Kota Singkawang',
    	'kota_sorong': 'Kota Sorong',
    	'kota_sukabumi': 'Kota Sukabumi',
    	'kota_surabaya': 'Kota Surabaya',
    	'kota_surakarta': 'Kota Surakarta',
    	'kota_surakarta_solo': 'Kota Solo',
    	'kota_tangerang': 'Kota Tangerang',
    	'kota_tanjung': 'Kota Tanjung',
    	'kota_tanjung_pandan': 'Kota Tanjung Pandan',
    	'kota_tanjung_pinang': 'Kota Tanjung Pinang',
    	'kota_tarakan': 'Kota Tarakan',
    	'kota_tasikmalaya': 'Kota Tasikmalaya',
    	'kota_tegal': 'Kota Tegal',
    	'kota_tembilahan': 'Kota Tembilahan',
    	'kota_ternate': 'Kota Ternate',
    	'kota_tual': 'Kota Tual',
    	'kota_yogyakarta': 'Kota Yogyakarta'};
export const pDict ={
	'aceh': 'Aceh',
	'bali': 'Bali',
	'banten': 'Banten',
	'bengkulu': 'Bengkulu',
	'di_yogyakarta': 'DI Yogyakarta',
	'dki_jakarta': 'DKI Jakarta',
	'gorontalo': 'Gorontalo',
	'jambi': 'Jambi',
	'jawa_barat': 'Jawa Barat',
	'jawa_tengah': 'Jawa Tengah',
	'jawa_timur': 'Jawa Timur',
	'kalimantan_barat': 'Kalimantan Barat',
	'kalimantan_selatan': 'Kalimantan Selatan',
	'kalimantan_tengah': 'Kalimantan Tengah',
	'kalimantan_timur': 'Kalimantan Timur',
	'kalimantan_utara': 'Kalimantan Utara',
	'kepulauan_bangka_belitung': 'Kepulauan Bangka Belitung',
	'kepulauan_riau': 'Kepulauan Riau',
	'lampung': 'Lampung',
	'maluku': 'Maluku',
	'maluku_utara': 'Maluku Utara',
	'nusa_tenggara_barat': 'Nusa Tenggara Barat',
	'nusa_tenggara_timur': 'Nusa Tenggara Timur',
	'papua': 'Papua',
	'papua_barat': 'Papua Barat',
	'riau': 'Riau',
	'sulawesi_barat': 'Sulawesi Barat',
	'sulawesi_selatan': 'Sulawesi Selatan',
	'sulawesi_tengah': 'Sulawesi Tengah',
	'sulawesi_tenggara': 'Sulawesi Tenggara',
	'sulawesi_utara': 'Sulawesi Utara',
	'sumatera_barat': 'Sumatera Barat',
	'sumatera_selatan': 'Sumatera Selatan',
	'sumatera_utara': 'Sumatera Utara'};

export const pDropdownDict =[

	{label:'Aceh', value: 'aceh'},
	{label: 'Bali', value: 'bali'},
	{label: 'Banten', value: 'banten'},
	{label: 'Bengkulu', value: 'bengkulu'},
	{label: 'DI Yogyakarta',  value: 'di_yogyakarta'},
	{label: 'DKI Jakarta',  value: 'dki_jakarta'},
	{label: 'Gorontalo',  value: 'gorontalo'},
	{label: 'Jambi',  value: 'jambi'},
	{label: 'Jawa Barat',  value: 'jawa_barat'},
	{label: 'Jawa Tengah',  value: 'jawa_tengah'},
	{label: 'Jawa Timur',  value: 'jawa_timur'},
	{label: 'Kalimantan Barat',  value: 'kalimantan_barat'},
	{label: 'Kalimantan Selatan',  value: 'kalimantan_selatan'},
	{label: 'Kalimantan Tengah',  value: 'kalimantan_tengah'},
	{label: 'Kalimantan Timur',  value: 'kalimantan_timur'},
	{label: 'Kalimantan Utara',  value: 'kalimantan_utara'},
	{label: 'Kepulauan Bangka Belitung',  value: 'kepulauan_bangka_belitung'},
	{label: 'Kepulauan Riau',  value: 'kepulauan_riau'},
	{label: 'Lampung', value: 'lampung'},
	{label: 'Maluku',  value: 'maluku'},
	{label: 'Maluku Utara',  value: 'maluku_utara'},
	{label: 'Nusa Tenggara Barat',  value: 'nusa_tenggara_barat'},
	{label: 'Nusa Tenggara Timur',  value: 'nusa_tenggara_timur'},
	{label: 'Papua',  value: 'papua'},
	{label: 'Papua Barat',  value: 'papua_barat'},
	{label: 'Riau',  value: 'riau'},
	{label: 'Sulawesi Barat',  value: 'sulawesi_barat'},
	{label: 'Sulawesi Selatan',  value: 'sulawesi_selatan'},
	{label: 'Sulawesi Tengah',  value: 'sulawesi_tengah'},
	{label: 'Sulawesi Tenggara',  value: 'sulawesi_tenggara'},
	{label: 'Sumatera Barat',  value: 'sumatera_barat'},
	{label: 'Sulawesi Utara', value: 'sulawesi_utara'} ,
	{label: 'Sumatera Selatan', value: 'sumatera_selatan'},
	{label: 'Sumatera Utara', value: 'sumatera_utara'},

];

export const comDict = {
	'bawang_merah' : 'Bawang Merah',
	'bawang_putih' : 'Bawang Putih',
	'beras' : 'Beras',
	'cabai_merah' : 'Cabai Merah',
	'cabai_rawit' : 'Cabai Rawit',
	'daging_ayam' : 'Daging Ayam',
	'daging_sapi' : 'Daging Sapi',
	'gula_pasir' : 'Gula Pasir',
	'minyak_goreng' : 'Minyak Goreng',
	'telur_ayam' : 'Telur Ayam'
};

export const svgDict = {
	'bawang_merah' : <BawangMerah height={'inherit'} width={'inherit'}/>,
	'bawang_putih' : <BawangPutih height={'inherit'} width={'inherit'}/>,
	'beras' : <Beras height={'inherit'} width={'inherit'}/>,
	'cabai_merah' : <CabaiMerah height={'inherit'} width={'inherit'}/>,
	'cabai_rawit' : <CabaiRawit height={'inherit'} width={'inherit'}/>,
	'daging_ayam' : <DagingAyam height={'inherit'} width={'inherit'}/>,
	'daging_sapi' : <DagingSapi height={'inherit'} width={'inherit'}/>,
	'gula_pasir' : <GulaPasir height={'inherit'} width={'inherit'}/>,
	'minyak_goreng' : <MinyakGoreng  height={'inherit'} width={'inherit'}/>,
	'telur_ayam' : <TelurAyam height={'inherit'} width={'inherit'}/>
};

export const epochDict = {
	'dini' : {'time' : '0', 'text':'Dini Hari', 'background': 'linear-gradient(218.1deg, #003F88 15.96%, #000000 77.3%)'},
	'pagi' : {'time' : '6', 'text':'Pagi Hari', 'background': 'linear-gradient(218.1deg, #FDC500 15.96%, #003F88 77.3%)'},
	'siang' : {'time' : '12', 'text':'Siang Hari', 'background': 'linear-gradient(218.1deg, #FF6868 15.96%, #FDC500 77.3%)'},
	'malam' : {'time' : '18', 'text':'Malam Hari', 'background': 'linear-gradient(47.18deg, #883232 17.62%, #032B5A 41.33%, #000000 80.82%)'},
};
export const weatherSvgDict = {
	'0_cerah': <CerahMalam height={'inherit'} width={'inherit'}/>,
	'6_cerah': <CerahPagi height={'inherit'} width={'inherit'}/>,
	'12_cerah': <CerahPagi height={'inherit'} width={'inherit'}/>,
	'18_cerah': <CerahMalam height={'inherit'} width={'inherit'}/>,

	'0_cerah_berawan': <CerahBerawanMalam />,
	'6_cerah_berawan': <CerahBerawanPagi />,
	'12_cerah_berawan': <CerahBerawanPagi />,
	'18_cerah_berawan': <CerahBerawanMalam />,

	'0_berawan': <BerawanMalam />,
	'6_berawan': <BerawanPagi />,
	'12_berawan': <BerawanPagi />,
	'18_berawan': <BerawanMalam />,

	'0_berawan_tebal': <BerawanTebalMalam />,
	'6_berawan_tebal': <BerawanTebalPagi />,
	'12_berawan_tebal': <BerawanTebalPagi />,
	'18_berawan_tebal': <BerawanTebalMalam />,

	'0_kabut': <KabutMalam />,
	'6_kabut': <KabutPagi />,
	'12_kabut': <KabutPagi />,
	'18_kabut': <KabutMalam />,

	'0_hujan_ringan': <HujanRinganMalam />,
	'6_hujan_ringan': <HujanRinganPagi />,
	'12_hujan_ringan': <HujanRinganPagi />,
	'18_hujan_ringan': <HujanRinganMalam />,

	'0_hujan_sedang': <HujanSedang />,
	'6_hujan_sedang': <HujanSedang />,
	'12_hujan_sedang': <HujanSedang />,
	'18_hujan_sedang': <HujanSedang />,

	'0_hujan_lebat': <HujanLebat />,
	'6_hujan_lebat': <HujanLebat />,
	'12_hujan_lebat': <HujanLebat />,
	'18_hujan_lebat': <HujanLebat />,
};

export const wCaption = {
	'0_cerah':'Cerah',
	'6_cerah':'Cerah',
	'12_cerah':'Cerah',
	'18_cerah':'Cerah',

	'0_cerah_berawan':'Cerah Berawan',
	'6_cerah_berawan':'Cerah Berawan',
	'12_cerah_berawan':'Cerah Berawan',
	'18_cerah_berawan':'Cerah Berawan',

	'0_berawan':'Berawan',
	'6_berawan':'Berawan',
	'12_berawan':'Berawan',
	'18_berawan':'Berawan',

	'0_berawan_tebal':'Berawan Tebal',
	'6_berawan_tebal':'Berawan Tebal',
	'12_berawan_tebal':'Berawan Tebal',
	'18_berawan_tebal':'Berawan Tebal',

	'0_kabut':'Berkabut',
	'6_kabut':'Berkabut',
	'12_kabut':'Berkabut',
	'18_kabut':'Berkabut',

	'0_hujan_ringan':'iHujan Ringan',
	'6_hujan_ringan':'Hujan Ringan',
	'12_hujan_ringan':'Hujan Ringan',
	'18_hujan_ringan':'Hujan Ringan',

	'0_hujan_sedang': 'Hujan Sedang',
	'6_hujan_sedang': 'Hujan Sedang',
	'12_hujan_sedang': 'Hujan Sedang',
	'18_hujan_sedang':'Hujan Sedang',

	'0_hujan_lebat':'Hujan Lebat',
	'6_hujan_lebat':'Hujan Lebat',
	'12_hujan_lebat':'Hujan Lebat',
	'18_hujan_lebat':'Hujan Lebat',
};

export const cycleOptions = [
	{label: 'Suhu Udara', value: 'temperature'},
	{label: 'Kelembapan Udara', value: 'humidity'},
	{label: 'Kecepatan Angin', value: 'wind_speed'}
];

export const radarNodeOptions = [
	{label:"Food Estate Ria Ria", value: "node_26"},
	{label:"TSTH2 Tanah Mineral I", value: "node_24"},
	{label:"TSTH2 Tanah Gambut", value: "node_25"},
	{label:"TSTH2 Tanah Mineral II", value: "node_12"},
	{label:"TSTH2 ZBNF Modified", value:"node_14"},
	{label:"Sumbul, Dairi", value:"node_2"},
	{label:"Tebet", value:"node_15"},
	//{label:"Poasia, Kota Kendari", value:"node_9"}
]

export const marvesRadarNodeOptions = [
	{label:"Food Estate Ria Ria", value: "node_26"},
	{label:"TSTH2 Tanah Mineral I", value: "node_24"},
	{label:"TSTH2 Tanah Gambut", value: "node_25"},
	{label:"TSTH2 Tanah Mineral II", value: "node_12"},
]

export const estateNodeOptions = [
	{label:"Food Estate Ria Ria", value: "node_26"},
]

export const radarModelPlantOptions = [
	{label: "Bawang Merah", value:'bawang_merah'},
	{label: "Bawang Putih", value:'bawang_putih'},
	{label: "Jagung", value:'jagung'},
	{label: "Ketela Pohon", value:'ketela_pohon'},
	{label: "Ketela Rambat", value:'ketela_rambat'},
	{label: "Cabai Rawit", value:'cabe_rawit'},
	{label: "Cabai Merah", value:'cabe_merah'},
	{label: "Kacang Kedelai", value:'kacang_kedelai'},
	{label: "Tebu", value:'tebu'},
	{label: "Kentang", value:'kentang'},
	{label: "Tomat", value:'tomat'},
	{label: "Kol", value:'kol'},
	{label: "Kacang Tanah", value:'kacang_tanah'},
	{label: "Kopi Arabika", value:'kopi_arabika'},
	// {label: "Kopi Robusta", value:'kopi_robusta'},
	{label: "Tembakau", value:'tembakau'},
	{label: "Teh", value:'teh'},
]

export const sthOptions = [
	{label: 'Suhu Tanah', value: 'soil_temperature'},
	{label: 'Kelembapan Tanah', value: 'soil_moisture'},
	{label: 'Suhu Udara dan Tanah', value: 'soil_and_air_temp'},
	{label: 'Kelembapan dan Salinitas Tanah', value: 'soil_moisture_and_salinity'}
];

export const sthBarOptions = [
	{label: 'Suhu Tanah', value: 'hist_soil_temperature'},
	{label: 'Kelembapan Tanah', value: 'hist_soil_moisture'},
];

//
// export const sthBarView = {
// 	'soil_temperature': <Histogram measurement={'soil_temperature'} sensor_id={'node_2'} />,
// 	'soil_moisture': <Histogram measurement={'soil_moisture'} sensor_id={'node_2'} />
// };

export const ambOptions = [
	{label: 'Cahaya Sekitar', value: 'ambient_light'},
	{label: 'Voltase Matahari', value: 'solar_voltage'}
];

export const ambBarOptions = [
	{label: 'Cahaya Sekitar', value: 'hist_ambient_light'},
	{label: 'Voltase Matahari', value: 'hist_solar_voltage'}
];

export const defaultSoilData = {
	"soil_conductivity": 0.0,
	"nitrogen": 0.0,
	"potassium": 0.0,
	"phosphorous": 0.0,
	"soil_ph": 7
}

